import { Location } from "@/interfaces/location";
import { Stems } from "@/interfaces/stems";
import { stemsForm } from "@/metadata/stems";
import { stemsService } from "@/services/stems.service";
import {
  DynamicFormComponent,
  FormField,
  FormResponse
} from "helix-vue-components";
import { Component, Vue } from "vue-property-decorator";
import { NavigationDrawerComponent } from "../NavigationDrawer/NavigationDrawer.component";
import Template from "./Stems.template.vue";

@Component({
  mixins: [Template],
  components: {
    NavigationDrawerComponent,
    DynamicFormComponent
  }
})
export default class StemsComponent extends Vue {
  public get enableText(): string {
    if (!this.model) {
      return "";
    }

    const { enabled } = this.model;
    return this.$t(enabled ? "stems.disable" : "stems.enable") as string;
  }

  public locations: Array<Partial<Location>> = [];
  public model: Stems | null = null;
  public fieldsConfig: FormField[] = stemsForm;
  public form!: DynamicFormComponent;
  public active = false;

  public async filterSelected(filter: Location) {
    this.active = true;
    const stems = await stemsService.getStems(filter.id);
    this.model = stems;
  }

  public async save() {
    const resp: FormResponse = await this.form.submit();
    if (!resp.valid) {
      return;
    }

    stemsService.updateStems(resp.currentModel as Stems);
  }

  public async mounted() {
    this.form = this.$refs["stems-form"] as DynamicFormComponent;
    this.locations = await stemsService.getLocations();
  }
}
